/**
 * Lista de espacios de nombres de i18next (un JSON por idioma en
 * `src/locales/<idioma>/<espacio>.json`).
 *
 * - `common`: elementos compartidos (navegación, pie, banner de cookies, acciones).
 * - `seo`: título y descripción de cada página (ver `seoMeta.js`).
 * - Resto: un espacio por área de la web (`home`, `about`, `products`, `recipes`,
 *   `news`, `contact`) más `forms` (formularios y sus validaciones).
 *
 * Al añadir uno: crear los 4 JSON, importarlos en `config.js` y añadirlo aquí.
 */
export const NAMESPACES = ['common', 'forms', 'contact', 'home', 'about', 'products', 'recipes', 'news', 'legal', 'privacy', 'transparency', 'transparencySubsidies', 'transparencyDirectors', 'transparencyRules', 'seo'];
